import axios from 'axios'
import {
  message
} from 'ant-design-vue';


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  baseURL: '/apis/app',
  timeout: 30000,
  // 禁用 Cookie 等信息
  // withCredentials: false,
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.url = config.url + '?timestamp=' + new Date().getTime()
    console.log(config)
    return config
  },
  (error) => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
      if (res && res.data && res.data.status != 1) {
        message.error(res.data.payload.msg)
        return Promise.reject(res)
      }
      return res.data
    },
    (error) => {
      return Promise.reject(error)
    }
)

export default service